import { Observable, filter, map, merge, switchMap, take, timer } from 'rxjs';

import { appBecameActive$ } from './app-became-active';

const CHECK_INTERVAL_MS = 30_000;

// emits once when the timestamp has passed; a single one-shot timer is unreliable because
// timers stall under heavy main-thread load and are frozen while the device sleeps or the
// tab is throttled, so every polling tick and app-wake signal re-arms the one-shot with a
// freshly recalculated remaining delay

export const timestampExpired$ = (expiresTimestamp: string | number | Date): Observable<void> => {
  const expiresAtMs = new Date(expiresTimestamp).getTime();

  return merge(timer(0, CHECK_INTERVAL_MS), appBecameActive$).pipe(
    switchMap(() => timer(Math.max(expiresAtMs - Date.now(), 0))),
    filter(() => Date.now() >= expiresAtMs),
    take(1),
    map(() => void 0)
  );
};
